import closeSearchOverlay from "./thunks/closeSearchOverlay";
import Search from "./components/Search/Search";
import SearchOverlayProps from "./SearchOverlayProps";
import styles from "./SearchOverlay.module.scss";

import { FunctionComponent, useRef } from "react";
import { motion } from "framer-motion";
import { Portal } from "react-portal";
import { useDispatch } from "react-redux";
import combineClasses from "helpers/combine-classes";
import IconViewer from "components/IconViewer/IconViewer";
import React, { useState } from "react";

const SearchOverlay: FunctionComponent<SearchOverlayProps> = (props): JSX.Element => {
    const dispatch = useDispatch();
    const [closeButtonHovered, setCloseButtonHovered] = useState(false);

    const wrapperElementRef = useRef<any>(null);

    const isActiveClass = props.state === "SEARCH_OVERLAY" ? styles.is_active : undefined;
    const isClosingClass = props.state === "CLOSING_SEARCH_OVERLAY" ? styles.is_closing : undefined;

    const closeOverlay = () => {
        dispatch(closeSearchOverlay(wrapperElementRef));
    };

    return (
        <Portal node={document && document.getElementById("wrapper")}>
            <div className={combineClasses(styles.outer, isActiveClass, isClosingClass)} onClick={closeOverlay}></div>
            <div className={combineClasses(styles.wrapper, isActiveClass, isClosingClass)} style={props.headerStyles} ref={wrapperElementRef}>
                <div className={styles.header}>
                    {/* Close Button */}
                    <motion.button onMouseEnter={() => setCloseButtonHovered(true)} onMouseLeave={() => setCloseButtonHovered(false)} animate={{ rotate: closeButtonHovered? 180 : 0 }} transition={{ duration: .3, ease: "easeInOut" }} className={styles.close_button} onClick={closeOverlay}>
                        <IconViewer className={styles.close_icon} name="close" />
                    </motion.button>
                </div>

                <Search wrapperElementRef={wrapperElementRef} />
            </div>
        </Portal>
    );
};

export default SearchOverlay;